import { Select } from "antd";
import { isEmpty } from "lodash";
import CardDiv from "modules/common/card-div/CardDiv";
import AssignedDoctorsTable from "modules/order_management/AssignedDoctorsTable";
import { useAssignedOrdersStore } from "modules/order_management/store";
import PaginationDiv from "modules/pagination/PaginationDiv";
import { getLineItemsName, getValue } from "modules/utilities/utility";
import React, { useEffect, useMemo, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";

function AssignedDoctors() {
  const {
    assignedOrderData,
    doctorData,
    assignedOrdersLoading,
    fetchAssignedOrdersData,
    fetchDoctorRoleData,
  } = useAssignedOrdersStore();

  const [assignedDoctor, setAssignedDoctor] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pageData = searchParams.get("pageNumber");
  const assignedDoctorId = searchParams.get("assignedDoctor");
  const [queryParams, setQueryParams] = useState("");
  const [page, newPage] = useState(1);
  const [searchCount, setSearchCount] = useState(0);

  useEffect(() => {
    const queryParamsMap = {
      assignedDoctor: assignedDoctorId && `&assignedDoctor=${assignedDoctorId}`,
    };
    const queryParams = Object.values(queryParamsMap).filter(Boolean).join("");
    setQueryParams(queryParams);
  }, [assignedDoctorId]);

  useEffect(() => {
    newPage(Number(pageData));
  }, [pageData]);

  useEffect(() => {
    fetchDoctorRoleData();
  }, []);

  useEffect(() => {
    setSearchCount(searchCount + 1);
    if (searchCount) {
      navigate(
        `/order-management/assigned-doctors?pageNumber=${page}${queryParams}`
      );
    }
  }, [page]);

  useEffect(() => {
    const queryParamsMap = {
      assignedDoctor: assignedDoctorId && `&assignedDoctor=${assignedDoctorId}`,
    };
    const queryParams = Object.values(queryParamsMap).filter(Boolean).join("");

    if (pageData) {
      fetchAssignedOrdersData(`pageNumber=${Number(pageData)}${queryParams}`);
    }
  }, [pageData, queryParams]);

  const onSubmit = (e) => {
    e.preventDefault();
    navigate(
      `/order-management/assigned-doctors?pageNumber=1&assignedDoctor=${assignedDoctor}`
    );
  };

  const handleClear = () => {
    navigate("/order-management/assigned-doctors?pageNumber=1");
  };

  const data = useMemo(() => {
    if (isEmpty(assignedOrderData)) return [];
    else {
      return assignedOrderData?.data?.map((row) => ({
        key: getValue(row, "id"),
        case_id: getValue(row, "case_id"),
        name: getValue(row, "user.first_name"),
        phone_Number: getValue(row, "user.phone_number"),
        orderDisplayId: getValue(row, "order_display_id"),
        orderName: getLineItemsName(row.order_meta?.line_items),
        orderStatus: getValue(row, "status"),
        orderDate: getValue(row, "created_at"),
        assignedDoctor: Array.prototype.map
          .call(getValue(row, "doctor"), (item) => ` ${item.user.first_name}`)
          .join(","),
        count: getValue(row, "count"),
        order_type: getValue(row, "order_type"),
        assignedTo: getValue(row, "assignment.first_name"),
        owner: getValue(row, "case.assignment.first_name"),
      }));
    }
}, [assignedOrderData]);

  return (
    <div>
      <CardDiv
        title={
          <div className="d-flex justify-content-between align-items-center">
            <div className="fs-2">Assigned Doctors</div>
            <div>
              <Form onSubmit={onSubmit} className="d-flex flex-row gap-2">
                <Form.Group controlId="assignedDoctor">
                  <Select
                    allowClear
                    dropdownStyle={{ minWidth: "10rem" }}
                    onChange={(e) =>
                      e ? setAssignedDoctor(e) : setAssignedDoctor("")
                    }
                    placeholder="Doctor"
                    style={{ minWidth: "15rem" }}
                  >
                    {doctorData &&
                      doctorData?.userRole?.map((users) => (
                        <Option value={users.user.id} key={users.user.id}>
                          {users.user.first_name}
                        </Option>
                      ))}
                  </Select>
                </Form.Group>

                <Button type="submit" variant="primary">
                  Apply
                </Button>
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={handleClear}
                >
                  Clear
                </button>
              </Form>
            </div>
          </div>
        }
        component={
          <div>
            <AssignedDoctorsTable
              tableData={data}
              isLoading={assignedOrdersLoading}
            />
            <div>
              <PaginationDiv
                paginationData={{
                  pageCount: assignedOrderData?.pagination?.pageCount
                    ? assignedOrderData?.pagination?.pageCount
                    : 1,
                  page: page,
                }}
                newPage={newPage}
              />
            </div>
          </div>
        }
      />
    </div>
  );
}

export default AssignedDoctors;
